<template>
  <v-row class="filter-box my-0" data-id-e2e="chainFilterSelect">
    <v-col cols="3" class="ps-0">
      {{ t('workpackagePage.splitWorkpackages.filterChainfilter') }}
    </v-col>
    <v-select
      v-model="selectedChains"
      :items="chains"
      hide-details
      white
      multiple
      :disabled="!chains.length"
      :placeholder="t('filterWorkpackagesOptions.noOption')"
      class="rtls-select rtls-select--white"
      data-id-e2e="chainSelect"
      @update:model-value="updateMainFilterObject()"
    >
      <template #selection="{ item, index }">
        <span v-if="index < 1" class="selected-items">{{ item.title }} &nbsp;</span>
        <span v-if="index === 1" class="text-grey text-caption">
          (+{{ selectedChains.length - 1 }} {{ t('workpackagePage.splitWorkpackages.moreChains') }})
        </span>
      </template>
      <template #prepend-item>
        <div class="sticky">
          <div class="d-flex justify-space-around align-center pt-2">
            <v-btn class="button-link" variant="text" @click="selectAll">
              <v-icon size="16"> mdi-check </v-icon>
              <span>{{ t('actions.selectAll') }}</span>
            </v-btn>
            <v-btn class="button-link" variant="text" @click="selectNone">
              <v-icon size="16"> mdi-checkbox-blank-outline </v-icon>
              <span>{{ t('actions.selectNone') }}</span>
            </v-btn>
          </div>
          <v-divider class="mt-2" />
        </div>
      </template>
    </v-select>
  </v-row>
</template>

<script>
import { map, compact, uniq, isEmpty, get, sortBy } from 'lodash';
import { mapState } from 'pinia';

// enums
import filterTypeEnum from '@enums/wp-filter-types';

// composables
import { useInternationalization } from '@/composables/use-internationalization';

// stores
import { useContextStore } from '@/stores/context';

export default {
  props: {
    wpFurniture: {
      type: Object,
      required: true,
    },
  },

  setup() {
    const { t } = useInternationalization();
    return { t };
  },

  data: () => ({ selectedChains: [] }),

  computed: {
    ...mapState(useContextStore, ['clientConfig']),

    furnitureChainRank() {
      return get(this.clientConfig, 'furnitureChainRank', {});
    },

    chains() {
      if (isEmpty(this.wpFurniture.furniture)) {
        return [];
      }

      const chains = uniq(
        compact(
          map(this.wpFurniture.furniture, f =>
            get(f, 'clientProvidedMetadata.furnitureChain', null)
          )
        )
      ).sort();

      // The order of values is: PR → SM → PM → ABC → Anything else is alphabetical order
      return sortBy(chains, chain => this.furnitureChainRank[chain]);
    },
  },

  watch: {
    // When the chains array gets initialised, we should select all by default.
    wpFurniture() {
      this.selectAll();
      this.$emit('updateMainFilterObject', {
        type: filterTypeEnum.chain,
        update: this.selectedChains,
        isInit: true,
      });
    },
  },

  methods: {
    async updateMainFilterObject() {
      this.$emit('updateMainFilterObject', {
        type: filterTypeEnum.chain,
        update: this.selectedChains,
      });
    },

    selectAll() {
      this.selectedChains = [...this.chains];
    },

    selectNone() {
      this.selectedChains = [];
      this.updateMainFilterObject();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

:deep(.v-select__selections) {
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: none;
}
:deep(.v-list) {
  position: relative;
}
.filter-box {
  align-items: center;

  span {
    padding-left: 0;
  }
}

.selected-items {
  padding-left: 5px !important;
}

.sticky {
  position: sticky;
  background-color: $canvas-header-white-background;
  top: 0;
}

.button-link {
  color: $assortment-primary-colour;
  padding: 0 !important;
  &::before,
  &::after {
    display: none !important;
  }

  span {
    text-decoration: underline;
  }
}
</style>
